import React, { Component } from 'react';
import { ThemeProvider } from 'styled-components';
import { withRouter } from 'react-router-dom';
import queryString from "query-string";
import Header from './CommonComponents/Header/Header';
import HeaderAdmin from './CommonComponents/HeaderAdmin/HeaderAdmin';
import Routes from './routes/Routes';
import Footer from './CommonComponents/Footer/Footer';
import IdleWrapper from './CommonComponents/IdleWrapper/IdleWrapper';
import theme from './styles/theme';
import SessionTimeOut from './CommonComponents/SessionTimeOut/SessionTimeOut';
import { FallBackError } from "./CommonComponents/GlobalErrors";
import {  
  getAccountData,  
  isGeminiUser,  
  setGeminiSessionData,  
  setUserAccounts,
  refreshToken,
  getTokenInfo
} from './utils/sessionUtil';
import Preloader from './CommonComponents/Preloader/Preloader';
import { adminUsage, financialAdvisorUsage } from './utils/commonUtil';
import { connect } from 'react-redux';
import SessionProvider, { logOut } from './Auth0/SessionProvider';
import { fetchUserInfo, makeUserSessionSuccess } from './actions/globalActions';
import Login from './Auth0/Login';

class App extends Component {
  constructor(props) {
    super(props);    
    if (process.env.REACT_APP_NODE_ENV === 'development' &&
        isGeminiUser()) {
      setGeminiSessionData();
    }

    this.state = {   
      isLoggedIn: false,
      userData: {},
      showLoginScreen: process.env.REACT_APP_NODE_ENV === 'development' && !isGeminiUser()  
    };
  }

  componentDidMount() {
    if(getTokenInfo()) {
      refreshToken((err, data) => { }, 480000);
    }
  }

  /**Added life cycle method to set user session after MFA authentication*/
  static getDerivedStateFromProps(props, state) {    
    if(props.userData && JSON.stringify(props.userData) !== JSON.stringify(state.userData)) {    
      setUserAccounts(props.userData);   
      return { isLoggedIn: true, userData: props.userData };
    } else if (!!props.userDataError && !isGeminiUser()) {      
      logOut();
    }
    return state;
  }

  /**Added life cycle to check whether the logged in user 
   * is financial advisor or not and route them into appropriate pages
   */
  componentDidUpdate(prevProps) {
    const { userData, history, dispatch } = this.props;
    let query = window.location.search;
    if(userData && query.includes('code=') && query.includes('state=')) {
      if(!userData.financialAdvisorForAnyAccount) {
        history.push("/");
      } else {
        history.push("/financialadvisor");
      }
    } else if(JSON.stringify(prevProps.userData) !== JSON.stringify(userData) && userData && isGeminiUser()) {
      dispatch(makeUserSessionSuccess());      
    }
  }
  
  renderHeader = (isAdminFlow, isAdminPage, isFinancialAdvisor) => {
    if (isGeminiUser() || !isAdminPage) {
      return <Header {...this.props} />;
    }
    else if (isAdminPage && !isGeminiUser()) {
      return <HeaderAdmin />;
    } 
  };

  /**Function to get logged in user details */
  handleSession = (isCsr=false) => {

    const { dispatch } = this.props;

    const params = queryString.parse(window.location.search);

    let url = '';    

    if(isCsr) {
      let { dafAccountId, ciPartyId} = params;
      //If condition added to get account id from session storage while duplicating the tab
      if(!dafAccountId) {
        const userData = getAccountData();
        dafAccountId = userData && userData.PrimaryAccountForParty ? userData.PrimaryAccountForParty: '';
      }
      //End
      url = `/donor-portal/api/account/findAcctDetailsForCSRUserByAcctId?accountId=${dafAccountId}`;      
      if(ciPartyId && ciPartyId !== 'null') {        
        url = `${url}&partyId=${ciPartyId}`;
      }
    } else {      
      url = '/donor-portal/api/user/null/getUserInfo'; //Warning! If any changes to this url path will have an impact on requestInterface.js file.
    }
    
    if(process.env.REACT_APP_NODE_ENV === 'development') {
      if(!isCsr) {
        (async () => {
          try {
            const { auth0 } = window;
            await auth0.getTokenSilently();
            this.setState({
              showLoginScreen: false
            }, () => {
              dispatch(fetchUserInfo({
                metaData: {
                    method: "GET",
                    url:  url,
                    page: 'root'          
                }
              }));
            });
          }
          catch(e) {
              console.log("Error: ", e);            
          }
        })();
      } else if(process.env.REACT_APP_POST_MESSAGE === "true") {        
        window.addEventListener("message", (e) => {
          if(e.origin === process.env.REACT_APP_GEMINI_CSR_URL) {
            sessionStorage.setItem("tokenInfo", e.data['tokenInfo']);          
            dispatch(fetchUserInfo({
              metaData: {
                  method: "GET",
                  url:  url,
                  page: 'root'          
              }
            }));
          }
        });    
  
        window.top.frames.top.postMessage("ready", process.env.REACT_APP_GEMINI_CSR_URL);
      } else {
        dispatch(fetchUserInfo({
          metaData: {
              method: "GET",
              url:  url,
              page: 'root'          
          }
        }));
      }

    } else {
      dispatch(fetchUserInfo({
        metaData: {
            method: "GET",
            url:  url,
            page: 'root'          
        }
      }));
    }
    
  }

  render() {
    let userData = JSON.parse(sessionStorage.getItem('userData'));
    const isAdminFlow = userData ? userData.csrUser : null;
    // DO NOT RENDER HEADER IF NEW WINDOW IS OPENED
    const { isRefresh = false } = queryString.parse(this.props.location.search);
    // Check user data loaded - Only for CSR User
    let userSessionLoaded = isGeminiUser() ? !this.props.userSessionLoading : true;    
    return ( 
       <SessionProvider       
              handleCallback={this.handleSession.bind(this)}>
        {
          process.env.REACT_APP_NODE_ENV === 'development' && !isGeminiUser() && this.state.showLoginScreen
          ? <Login />
          : (<div>
            {this.state.isLoggedIn ? (
              <ThemeProvider theme={theme}>
                <>
                  <IdleWrapper />
                  <SessionTimeOut />
                  
                  {  !isRefresh && userSessionLoaded ? this.renderHeader(
                    isAdminFlow,
                    adminUsage.isAdminPage,
                    financialAdvisorUsage(this.props)
                  ) : ''}

                  <main>
                    <Routes userSessionLoaded={userSessionLoaded}/>
                  </main>  
                  
                  <Footer />
                  <FallBackError />
                </>
              </ThemeProvider>
            ) : (
                <div>
                  <Preloader />
                </div>
            )}
          </div>)
        }
      </SessionProvider>
    );
  }
}

function mapStateProps(state) {
  return {
    userSessionLoading: state.getIn(["globalState", "accountdetails_data", "isLoading"]),
    userData: state.getIn(["globalState", "userInfo", "data"]),
    userDataError: state.getIn(["globalState", "userInfo", "error"])
  }
}

export default withRouter(connect(mapStateProps)(App));
